import React from "react";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image, children, testid, imageClass = "opacity-30", overlayClass = "from-bsn-midnight/85 via-bsn-midnight/80 to-bsn-midnight" }) => (
  <section className="relative bg-bsn-midnight text-bsn-parchment overflow-hidden" data-testid={testid}>
    {image && (
      <>
        <img src={image} alt="" className={`absolute inset-0 w-full h-full object-cover ${imageClass}`} />
        <div className={`absolute inset-0 bg-gradient-to-b ${overlayClass}`} />
      </>
    )}
    <div className="relative max-w-5xl mx-auto px-4 py-20 sm:py-28 text-center">
      {eyebrow && <Reveal><p className="eyebrow text-bsn-gold mb-4">{eyebrow}</p></Reveal>}
      <Reveal delay={80}>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-balance">
          {title}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={160}>
          <p className="mt-6 text-lg text-bsn-ice/80 leading-relaxed max-w-2xl mx-auto text-balance">{subtitle}</p>
        </Reveal>
      )}
      {children && <Reveal delay={240}><div className="mt-8">{children}</div></Reveal>}
    </div>
  </section>
);

export const SectionTitle = ({ eyebrow, title, subtitle, light = false, center = true, large = false }) => (
  <div className={`${center ? "text-center mx-auto" : ""} ${large ? "max-w-3xl" : "max-w-2xl"} mb-12`}>
    {eyebrow && <p className={`eyebrow mb-3 ${large ? "text-sm" : ""}`}>{eyebrow}</p>}
    <h2 className={`font-serif ${large ? "text-4xl sm:text-5xl lg:text-6xl" : "text-3xl sm:text-4xl"} font-semibold tracking-tight leading-snug ${light ? "text-bsn-parchment" : "text-bsn-midnight"}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-4 ${large ? "text-lg sm:text-xl" : "text-base"} leading-relaxed ${light ? "text-bsn-ice/75" : "text-bsn-sapphire/80"}`}>{subtitle}</p>}
  </div>
);
